import { render, staticRenderFns } from "./CorrectContainerNumber.vue?vue&type=template&id=22ede4c3"
import script from "./CorrectContainerNumber.vue?vue&type=script&lang=js"
export * from "./CorrectContainerNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports